// Allow to be set from config so users can customise
export const PRICE_UPDATE_THROTTLE = 1000;
export const PRICE_UPDATE_TIMEOUT = 15000;
export const PYTH_SERVER_DEFAULT = 'https://hermes.pyth.network/';
//# sourceMappingURL=prices.js.map